import type { FIXED_INDENTS } from 'vars/fixed-indents'
import type { CARDS_ASPECT_RATIO } from '../Card.h'

import { styled } from '@linaria/react'
import { PosterSC } from 'atoms/ImagePoster'
import { BaseCardSC, ImageBackgroundSC, PosterContainerSC } from '../base-card'

export const PartnerProgramCardContentWrapperSC = styled.div<{
  gap?: FIXED_INDENTS
  aspectRatio?: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
}>`
  cursor: default;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ gap }) => `var(${gap})`};

  ${BaseCardSC} {
    height: ${({ aspectRatio }) => `calc(var(--cardWidth) / ${aspectRatio})`};

    ${PosterContainerSC} {
      z-index: 1;

      ${ImageBackgroundSC} {
        ${PosterSC} {
          object-fit: cover;
        }
      }
    }
  }
`
